// Why a Company is due for a Monitoring Run; a Company may be due for several.
// A Retry is never one: it rides along when the Company is due for another
// reason (ADR-0176, a Company whose only due Research Tasks are retries is not
// stale). Each reason is the work of one step: Research needs a full Run, a
// File only a compile-only one.
export enum CompanyDueReason {
  SNAPSHOT_WAITING = "snapshot_waiting",
  NO_FILE = "no_file",
  FAILED_RUN = "failed_run",
  FAILED_AFTER_RESEARCH = "failed_after_research",
  RESEARCH_NEVER_CHECKED = "research_never_checked",
  RESEARCH_STALE = "research_stale",
  RESEARCH_DEFERRED = "research_deferred",
  IDENTITY_CHANGE = "identity_change",
  FILE_BEHIND_RESEARCH = "file_behind_research",
  INDIVIDUAL_LINK = "individual_link",
}

export const dataByCompanyDueReason: Record<
  CompanyDueReason,
  // `emptyText` completes "No Company …" when no Company is due for it.
  { step: "Research" | "File"; label: string; emptyText: string }
> = {
  [CompanyDueReason.SNAPSHOT_WAITING]: {
    step: "File",
    label: "Snapshot waiting",
    emptyText: "has a snapshot waiting for a File",
  },
  [CompanyDueReason.NO_FILE]: {
    step: "File",
    label: "No File",
    emptyText: "is due for want of a File",
  },
  // The last Run failed before its Research froze, so Research runs again.
  [CompanyDueReason.FAILED_RUN]: {
    step: "Research",
    label: "Last Run failed",
    emptyText: "is due after a Run that failed before its Research froze",
  },
  // The last Run froze its Research and failed later, so a compile-only Run
  // can write the File from that Research.
  [CompanyDueReason.FAILED_AFTER_RESEARCH]: {
    step: "File",
    label: "Last Run failed after Research",
    emptyText: "is due after a Run that failed after its Research froze",
  },
  [CompanyDueReason.RESEARCH_NEVER_CHECKED]: {
    step: "Research",
    label: "Unchecked Sources",
    emptyText: "has a Source never checked",
  },
  [CompanyDueReason.RESEARCH_STALE]: {
    step: "Research",
    label: "Stale Research",
    emptyText: "has Research past its freshness window",
  },
  [CompanyDueReason.RESEARCH_DEFERRED]: {
    step: "Research",
    label: "Deferred Research",
    emptyText: "has Research an earlier Run deferred",
  },
  [CompanyDueReason.IDENTITY_CHANGE]: {
    step: "Research",
    label: "Identity change",
    emptyText: "has an identity change since its last Research",
  },
  [CompanyDueReason.FILE_BEHIND_RESEARCH]: {
    step: "File",
    label: "File behind Research",
    emptyText: "has Research with an identity change its File lacks",
  },
  [CompanyDueReason.INDIVIDUAL_LINK]: {
    step: "File",
    label: "Individual link changed",
    emptyText: "has an Individual link that changed since its File",
  },
}
